import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { AssistantTestModule } from "../../modules/AssistantTestModule/AssistantTestModule";

const AssistantTestScreen = () => {
  return (
    <ScreenLayout>
      <AssistantTestModule />
    </ScreenLayout>
  );
};

export default AssistantTestScreen;
